<template>
  <div class="flex h-full ">
    <!--    TODO transition for the menu opening with width properties-->
    <navigation :class="{'w-64': showMenu}" class="fixed transition z-10 w-12 sm:w-64"/>
    <!--    <div :class="{'w-full': showMenu}" class=" w-0 sm:hidden bg-black opacity-25  fixed z-10 right-0 h-full">-->
    <!--    TODO Darker Background for openMenu-->
    <!--    </div>-->
    <div class="w-full transition relative ml-12 sm:ml-64 bg-background-secondary">
      <top-bar class="text-txt-primary absolute"/>
      <loading-bar v-if="showLoading" class="w-full bg-black h-1 absolute"/>
      <div class="relative mt-1 p-2">
        <router-view class="text-txt-primary bg-background-primary"/>
      </div>
    </div>

  </div>

  <!--    <div class="flex h-full">-->
  <!--      <SideBar :activeComponent="activeComponent" :class="{'w-56': openMenu}" class="w-12 z-10 sm:w-64 fixed"></SideBar>-->
  <!--      <div :class="{'w-56': openMenu}" class=" w-12 sm:w-64  fixed z-0 h-full"-->
  <!--           style=" background: linear-gradient(180deg, #722ded 0%, #a67bf4 100%);">-->

  <!--      </div>-->
  <!--      <div :class="{'ml-56': openMenu,'translate-x-56':openMenu}" class="w-full sm:p-4 ml-12 sm:ml-64">-->

  <!--        <TopBar class="mb-2 sm:mb-4"></TopBar>-->
  <!--        <div class="flex w-full">-->
  <!--          <component :is="activeComponent"/>-->
  <!--        </div>-->
  <!--      </div>-->
  <!--    </div>-->
</template>

<script>
import Navigation from '../components/navigation/Navigation'
import TopBar from '../components/navigation/Header'
import LoadingBar from '../components/global_UI/LoadingBar'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'main-layout',
  components: {
    Navigation,
    TopBar,
    LoadingBar
  },
  data: () => ({}),
  computed: {
    ...mapGetters({
      showMenu: 'rwd/show_menu',
      showLoading: 'rwd/show_loading'
    })
  },
  methods: {
    ...mapActions({
      toggleMenu: 'rwd/toggleMenu'
    })
  }

}
</script>

<style scoped>
.transition {
  /*transition: all ease-in-out .3s;*/
}
</style>
